<template>
  <div class="mb-6">
    <div v-if="!value">
      <v-file-input
        :rules="ruleList.concat(fileValidation)"
        accept=".xlsx"
        class="mb-4"
        dense
        outlined
        placeholder="Choose file"
        ref="file"
        show-size
        v-model="fileUpload"
      ></v-file-input>
      <v-btn v-if="uploading" :disabled="true" color="primary" outlined x-small
        >Uploading
        <v-icon class="spinner ml-2" small width="10px"
          >fa fa-spinner</v-icon
        ></v-btn
      >
      <v-btn
        v-else
        :disabled="!fileUpload"
        color="primary"
        outlined
        v-on:click="upload(attributeName)"
        x-small
        >Upload</v-btn
      >
    </div>
    <div v-else>
      <span>{{ fileName }}</span>
      <v-btn
        class="ml-4"
        color="primary"
        outlined
        v-on:click="uploadClear(attributeName)"
        x-small
        >Clear</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "axios";

import formElementMixin from "./formElementMixin";

export default {
  computed: {
    fileName() {
      const file = this.getFileById(this.value);

      if (!file) {
        return;
      }

      return file.name;
    },
    userImportFileTypeId() {
      const userImportFileType = this.fileTypeList.find(
        item => item.name === "userImport"
      );
      if (!userImportFileType) return;
      return userImportFileType.id;
    },
    ...mapGetters({
      getFileById: "file2/getByIdAdmin",
    }),
    ...mapState({
      fileTypeList: state => state.fileType.list,
    }),
  },
  async created() {
    try {
      await this.getFileList();
      await this.getFileTypeList();
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Unable to load file data" });
      return;
    }
  },
  data() {
    return {
      fileUpload: undefined,
      fileValidation: [
        value => !value || value.size < 2e6 || "File must be under 2 MB",
        () => !this.fileUpload || "File must be uploaded.",
      ],
      uploading: false,
    };
  },
  methods: {
    async upload() {
      if (!this.userImportFileTypeId) {
        return this.$notifyError({
          message: "Could not find 'userImport' file type in 'fileType' table.",
        });
      }

      const formData = new FormData();

      formData.append("file", this.fileUpload);
      formData.append("fileTypeId", this.userImportFileTypeId);

      let response;
      try {
        this.uploading = true;
        response = await axios({
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          method: "post",
          url: "/api/file2",
        });
      } catch (e) {
        console.error(e);
        let message = "Error uploading file";
        if (e.response) {
          message = e.response.data;
        }

        this.$notifyError({ message });
        this.uploading = false;
        return;
      }

      const { result: fileId } = response.data;

      await this.getFileList();
      this.value = fileId;
      this.uploading = false;
    },
    async uploadClear(attributeName) {
      const fileId = this.attributeMap[attributeName];

      try {
        await axios({
          method: "delete",
          url: `/api/file2/${fileId}`,
        });
      } catch (e) {
        const response = e.response || {};
        const { status } = response;

        // This is to allow "clearing" files that don't "exist".
        // Reason: all files have OrgIDs, but admin users uploading epic mappings change their OrgID
        // Fix: TOOLS-7817
        if (status !== 404) {
          const message = response.data || "Error removing file";
          this.$notifyError({ message });
          return;
        }
      }

      await this.getFileList();
      this.value = null;
    },
    ...mapActions({
      getFileList: "file2/listAdmin",
      getFileTypeList: "fileType/list",
    }),
  },
  mixins: [formElementMixin],
};
</script>
